import cn from 'clsx'
import { FC, MouseEvent } from 'react'

import { Typography } from '@/components/ui'
import NewSpinner from '@/components/ui/spinner/NewSpinner'

import Cancel from '@/assets/icons/cancel.svg'
import Success from '@/assets/icons/success.svg'

import { IUploadFileItemViewState } from '@/features/Home/helpers/getUploadFileItemViewState'

interface IUploadFileCardProps {
	source: string
	isActive: boolean
	viewState: IUploadFileItemViewState
	onClick: () => void | Promise<void>
	onCancelClick: () => void
}

const UploadFileCard: FC<IUploadFileCardProps> = ({
	source,
	isActive,
	viewState,
	onClick,
	onCancelClick
}) => {
	const handleClick = (event: MouseEvent<HTMLDivElement>) => {
		if ((event.target as HTMLElement).closest('.cancel-icon')) return

		onClick()
	}

	return (
		<div
			onClick={handleClick}
			className={cn(
				'flex justify-between items-center border-[3px] rounded-[12px] p-4 group bg-white',
				isActive ? 'border-black' : 'border-gray-300 hover:border-gray-200'
			)}
		>
			<div className='relative flex gap-2.5'>
				{/* Spinner for uploading and transcribing */}
				{viewState.showSpinner && (
					<NewSpinner className='min-w-6 mt-1' spinnerColor='#3075E8' />
				)}
				{viewState.showSuccessIcon && <Success className='min-w-6' />}

				<div className='flex flex-col gap-2'>
					{/* Filename */}
					<Typography
						variant='text'
						className={cn(
							viewState.kind === 'failed' ? 'text-red-500' : 'text-gray-600'
						)}
					>
						{source}
					</Typography>

					{/* Process status */}
					<Typography
						variant='text-semibold'
						className={cn(
							'w-fit px-[6px] py-1 rounded-[4px] relative text-gray-600 bg-white',
							viewState.kind === 'failed' && '!text-red-500 !bg-red-50',
							(viewState.kind === 'uploaded' ||
								viewState.kind === 'finished') &&
								'!text-green-700 !bg-green-50',
							viewState.kind === 'transcribing' &&
								'!text-yellow-700 !bg-yellow-50',
							viewState.kind === 'uploading' && '!bg-gray-50'
						)}
					>
						{/* Uploading progress in percents or with timer and transcribing progress with timer*/}
						{viewState.statusText}
					</Typography>
				</div>
			</div>

			<div>
				<Cancel
					className='w-4 h-4 opacity-0 group-hover:opacity-100 cursor-pointer cancel-icon'
					onClick={onCancelClick}
				/>
			</div>
		</div>
	)
}

export default UploadFileCard
